import { Decimal } from 'decimal.js';
import { formatAmount, FormatAmountOptions } from './format-amount';
import { DEFAULT_PLACEHOLDER } from '@insio/format-utils';

/**
 * Formats a `Decimal` as Money (amount + currency code).
 */
export function formatMoney(
  amount: Decimal | null | undefined,
  options: FormatAmountOptions
): string {
  const { currencyCode } = options;
  if (amount === null || amount === undefined) {
    return options?.placeholder ?? DEFAULT_PLACEHOLDER;
  }
  if (currencyCode === null || currencyCode === undefined) {
    return formatAmount(amount, options);
  }
  const formattedAmount = formatAmount(amount, options);
  if (options.addPercentSign) {
    return formattedAmount; // Don't add currency code if it's a percentage
  }
  return `${formattedAmount} ${currencyCode}`;
}
